//  @flow
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
  Page,
  Row,
  Col,
  Button,
  Notification,
  DatePicker,
  Spin,
  Divider,
} from "components/Atoms";

import * as Actions from "actions/seller/seller.store";

import "./styles.scss";
import {
  Avatar, Box, Card, Container, IconButton, Typography,
} from "@mui/material";
import { H2 } from "components/CustomTypography";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import KeyboardArrowRightRoundedIcon from "@mui/icons-material/KeyboardArrowRightRounded";
import LocationOnRoundedIcon from "@mui/icons-material/LocationOnRounded";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import PaymentsIcon from '@mui/icons-material/Payments';
import ImageIcon from '@mui/icons-material/Image';
import ViewListIcon from "@mui/icons-material/ViewList";
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
import LanguageIcon from '@mui/icons-material/Language';
import PercentIcon from '@mui/icons-material/Percent';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import InstagramIcon from '@mui/icons-material/Instagram';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import CustomSectionCreator from "components/CustomSectionCreator";
import LayersIcon from '@mui/icons-material/Layers';
import RememberMeIcon from '@mui/icons-material/RememberMe';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import CampaignIcon from '@mui/icons-material/Campaign';

// Component Imports

const StoreProfileHome = (props) => {
  const {
    getStoreProfile, serviceError, reqStatus, storeProfile, history,
  } = props;

  React.useEffect(() => {
    getStoreProfile();
  }, []);

  const sendNotification = (type, { title, description = "" }) => {
    Notification[type]({
      message: title,
      description,
    });
  };

  React.useEffect(() => {
    switch (reqStatus) {
      default:
        if (serviceError) {
          const feedback = {
            title: "Something went wrong!",
            description: serviceError.statusText,
          };
          // sendNotification("error", feedback);
        }
        break;
    }
  }, [serviceError, reqStatus]);

  const handlePage = (page) => () => {
    history.push({
      pathname: page,
    });
  };

  const { logo } = storeProfile;

  return (

    <Container>
      <Box m={2} display="flex" alignItems="center" className="position-relative">
        <Box>
          <Avatar onClick={handlePage("/myshop/logo")} src={logo && logo.length > 0 && logo[0].cdn.secure_url} className="profile-img" />
          <div className="camera-icon">
            <IconButton
              color="primary"
              aria-label="upload picture"
              component="span"
              onClick={handlePage("/myshop/logo")}
              size="large"
            >
              <PhotoCamera />
            </IconButton>
          </div>
        </Box>
        <Box ml={2} alignItems="center">
          <H2 fontSize={20}>{storeProfile.title}</H2>
        </Box>
      </Box>
      <CustomSectionCreator isSubtle={true} title="Promotion Packages" />
      <Box m={2}>
        <Card>
          <Box display="flex">
            <Box width="80%">
              <Typography className="cursor-pointer" onClick={handlePage("/subscriptions/store")}>
                <IconButton size="large">
                  <TrendingUpIcon />
                </IconButton>
                Packages (Video / Customer Alerts)
              </Typography>
            </Box>
            <Box width="20%">
              <Typography align="right">
                <IconButton size="large">
                  <KeyboardArrowRightRoundedIcon />
                </IconButton>
              </Typography>
            </Box>
          </Box>
        </Card>
      </Box>

      <CustomSectionCreator isSubtle={true} title="Video Calling" />
      <Box m={2}>
        <Card>
          <Box display="flex">
            <Box width="80%">
              <Typography className="cursor-pointer" onClick={handlePage("/myshop/appointments")}>
                <IconButton size="large">
                  <RememberMeIcon />
                </IconButton>
                Call Bookings
              </Typography>
            </Box>
            <Box width="20%">
              <Typography align="right">
                <IconButton size="large">
                  <KeyboardArrowRightRoundedIcon />
                </IconButton>
              </Typography>
            </Box>
          </Box>
        </Card>
      </Box>
      <Box m={2}>
        <Card>
          <Box display="flex">
            <Box width="80%">
              <Typography className="cursor-pointer" onClick={handlePage("/myshop/appointment-settings")}>
                <IconButton size="large">
                  <AccessTimeFilledIcon />
                </IconButton>
                Video Call Settings
              </Typography>
            </Box>
            <Box width="20%">
              <Typography align="right">
                <IconButton size="large">
                  <KeyboardArrowRightRoundedIcon />
                </IconButton>
              </Typography>
            </Box>
          </Box>
        </Card>
      </Box>

        <CustomSectionCreator isSubtle={true} title="Shop Settings" />
      <Box m={2}>
        <Card>
          <Box display="flex">
            <Box width="80%">
              <Typography className="cursor-pointer" onClick={handlePage("/myshop/offers")}>
                <IconButton size="large">
                  <PercentIcon />
                </IconButton>
                Offers
              </Typography>
            </Box>
            <Box width="20%">
              <Typography align="right">
                <IconButton size="large">
                  <KeyboardArrowRightRoundedIcon />
                </IconButton>
              </Typography>
            </Box>
          </Box>
        </Card>
      </Box>
      <Box m={2}>
        <Card>
          <Box display="flex">
            <Box width="80%">
              <Typography className="cursor-pointer" onClick={handlePage("/myshop/profile")}>
                <IconButton size="large">
                  <PersonRoundedIcon />
                </IconButton>
                Profile
              </Typography>
            </Box>
            <Box width="20%">
              <Typography align="right">
                <IconButton size="large">
                  <KeyboardArrowRightRoundedIcon />
                </IconButton>
              </Typography>
            </Box>
          </Box>
        </Card>
      </Box>
      <Box m={2}>
        <Card>
          <Box display="flex">
            <Box width="80%">
              <Typography className="cursor-pointer" onClick={handlePage("/myshop/photos")}>
                <IconButton size="large">
                  <ImageIcon />
                </IconButton>
                Photos
              </Typography>
            </Box>
            <Box width="20%">
              <Typography align="right">
                <IconButton size="large">
                  <KeyboardArrowRightRoundedIcon />
                </IconButton>
              </Typography>
            </Box>
          </Box>
        </Card>
      </Box>
      <Box m={2}>
        <Card>
          <Box display="flex">
            <Box width="80%">
              <Typography className="cursor-pointer" onClick={handlePage("/myshop/address")}>
                <IconButton size="large">
                  <LocationOnRoundedIcon />
                </IconButton>
                Address
              </Typography>
            </Box>
            <Box width="20%">
              <Typography align="right">
                <IconButton size="large">
                  <KeyboardArrowRightRoundedIcon />
                </IconButton>
              </Typography>
            </Box>
          </Box>
        </Card>
      </Box>
      <Box m={2}>
        <Card>
          <Box display="flex">
            <Box width="80%">
              <Typography className="cursor-pointer" onClick={handlePage("/myshop/social")}>
                <IconButton size="large">
                  <InstagramIcon />
                </IconButton>
                Social Pages
              </Typography>
            </Box>
            <Box width="20%">
              <Typography align="right">
                <IconButton size="large">
                  <KeyboardArrowRightRoundedIcon />
                </IconButton>
              </Typography>
            </Box>
          </Box>
        </Card>
      </Box>
      <Box m={2}>
        <Card>
          <Box display="flex">
            <Box width="80%">
              <Typography className="cursor-pointer" onClick={handlePage("/myshop/domain")}>
                <IconButton size="large">
                  <LanguageIcon />
                </IconButton>
                Website/Domain
              </Typography>
            </Box>
            <Box width="20%">
              <Typography align="right">
                <IconButton size="large">
                  <KeyboardArrowRightRoundedIcon />
                </IconButton>
              </Typography>
            </Box>
          </Box>
        </Card>
      </Box>
      <Box m={2}>
        <Card>
          <Box display="flex">
            <Box width="80%">
              <Typography className="cursor-pointer" onClick={handlePage("/myshop/service")}>
                <IconButton size="large">
                  <DeliveryDiningIcon />
                </IconButton>
                Delivery Charge
              </Typography>
            </Box>
            <Box width="20%">
              <Typography align="right">
                <IconButton size="large">
                  <KeyboardArrowRightRoundedIcon />
                </IconButton>
              </Typography>
            </Box>
          </Box>
        </Card>
      </Box>
      <Box m={2}>
        <Card>
          <Box display="flex">
            <Box width="80%">
              <Typography className="cursor-pointer" onClick={handlePage("/myshop/payment")}>
                <IconButton size="large">
                  <CurrencyRupeeIcon />
                </IconButton>
                Payment
              </Typography>
            </Box>
            <Box width="20%">
              <Typography align="right">
                <IconButton size="large">
                  <KeyboardArrowRightRoundedIcon />
                </IconButton>
              </Typography>
            </Box>
          </Box>
        </Card>
      </Box>
      <Box m={2}>
        <Card>
          <Box display="flex">
            <Box width="80%">
              <Typography className="cursor-pointer" onClick={handlePage("/myshop/tax")}>
                <IconButton size="large">
                  <PaymentsIcon />
                </IconButton>
                Tax
              </Typography>
            </Box>
            <Box width="20%">
              <Typography align="right">
                <IconButton size="large">
                  <KeyboardArrowRightRoundedIcon />
                </IconButton>
              </Typography>
            </Box>
          </Box>
        </Card>
      </Box>
      <Box m={2}>
        <Card>
          <Box display="flex">
            <Box width="80%">
              <Typography className="cursor-pointer" onClick={handlePage("/myshop/returns")}>
                <IconButton size="large">
                  <KeyboardReturnIcon />
                </IconButton>
                Return Policy
              </Typography>
            </Box>
            <Box width="20%">
              <Typography align="right">
                <IconButton size="large">
                  <KeyboardArrowRightRoundedIcon />
                </IconButton>
              </Typography>
            </Box>
          </Box>
        </Card>
      </Box>

      <CustomSectionCreator isSubtle={true} title="Customer Notification" />

      <Box m={2}>
        <Card>
          <Box display="flex">
            <Box width="80%">
              <Typography className="cursor-pointer" onClick={handlePage("/myshop/contacts")}>
                <IconButton size="large">
                  <CampaignIcon />
                </IconButton>
                Manage Contacts / Send Alerts
              </Typography>
            </Box>
            <Box width="20%">
              <Typography align="right">
                <IconButton size="large">
                  <KeyboardArrowRightRoundedIcon />
                </IconButton>
              </Typography>
            </Box>
          </Box>
        </Card>
      </Box>

      <CustomSectionCreator isSubtle={true} title="Buy Wholesale" />
      <Box m={2}>
        <Card>
          <Box display="flex">
            <Box width="80%">
              <Typography className="cursor-pointer" onClick={handlePage("/products")}>
                <IconButton size="large">
                  <LayersIcon />
                </IconButton>
                Wholesale Marketplace
              </Typography>
            </Box>
            <Box width="20%">
              <Typography align="right">
                <IconButton size="large">
                  <KeyboardArrowRightRoundedIcon />
                </IconButton>
              </Typography>
            </Box>
          </Box>
        </Card>
      </Box>
      <br />
      <br />
      <br />
    </Container>

  );
};
// Mapping Props and State.
const _StoreProfileHome = connect(
  ({ store, appBase }) => ({
    appBase,
    reqStatus: store.reqStatus,
    isLoading: store.isLoading,
    serviceError: store.serviceError,
    storeProfile: store.storeProfile,
    storeDomain: store.storeDomain,
    storeAddress: store.storeAddress,
    storeImages: store.storeImages,
  }),
  (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(StoreProfileHome);

export { _StoreProfileHome as default };
